// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-windows"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 11V6.15152L10 5V11H3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M13 11V4.14286L21 3V11H13Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M13 19.8333V14H21V21L13 19.8333Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 19.3333V14H10V20L3 19.3333Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M3 11V6.15152L10 5V11H3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M13 11V4.14286L21 3V11H13Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M13 19.8333V14H21V21L13 19.8333Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M3 19.3333V14H10V20L3 19.3333Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const LogoWindowsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-windows',
    ref,
    icon: element,
  },
));

LogoWindowsIcon.displayName = 'LogoWindowsIcon';

export default LogoWindowsIcon;
